import React, { useState } from 'react';
import {
    useGetStats,
    useGetMergedLinkForShootPending,
    useGetDownloadXLSheetReport,
    useGetTeamDetailsOfShoot,
    useGetSkuSessionInfo,
} from '../../../hooks/usePhotoShootSession';
import { Statistic, Row, Col, Card, Button, DatePicker, Empty, message, Tooltip, Tag, Switch } from 'antd';
import { QuestionCircleOutlined, TeamOutlined, UnorderedListOutlined } from '@ant-design/icons';
import './index.scss';
import stc from 'string-to-color';
import CountUp from 'react-countup';
import { useNavigate } from 'react-router-dom';
import DynamicModal from '../../../commonComponents/DynamicModal/DynamicModal';
import TeamInformation from '../TeamInformation/TeamInformation';
import SkuSessionInfo from '../SkuSessionInfo/SkuSessionInfo';
import useLogout from '../../../hooks/useLogout';
import moment from 'moment';
import { getPhotoShootSessionDate } from '../../../utils/photoShootSessionDate';

const formatter = value => <CountUp end={value} separator="," duration={1} />;

const statTitle = (label, hint) => (
    <span>
        {label}{' '}
        <Tooltip title={hint}>
            <QuestionCircleOutlined />
        </Tooltip>
    </span>
);

const CompletedStats = ({ completedDetails, isGetSessionFeching, isSessionFetching }) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                width: '100%',
                gap: '3%',
                overflow: 'auto',
                padding: '0 1rem',
                backgroundColor: '#FFF4E0',
                borderRadius: '15px',
            }}
        >
            {completedDetails?.map((item, key) => (
                <Statistic
                    key={key}
                    title={item?.productType || '-'}
                    value={item?.count || ''}
                    loading={isGetSessionFeching || isSessionFetching}
                    style={{
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                    }}
                />
            ))}
        </div>
    );
};

export default function LiveShootOld() {
    const [selectedDate, setSelectedDate] = useState(null);
    const [autoReload, setAutoReload] = useState(false);
    const [isDownloadingReport, setIsDownloadingReport] = useState(false);
    const [currentShootTeamHistory, setCurrentShootTeamHistory] = useState(null);
    const navigate = useNavigate();
    const { logout } = useLogout();
    const { data, refetch, isFetching } = useGetStats(selectedDate, autoReload);
    const sessions = data?.sessions;
    const GetMergedLinkForShootPendingMutation = useGetMergedLinkForShootPending();
    const GetDownloadXLSheetReportMutation = useGetDownloadXLSheetReport();
    const [skuSessionInfoModal, setSkuSessionInfoModal] = useState(false);
    const [skuSessionData, setSkuSessionData] = useState([]);
    const [filteredSkuInfoData, setFilteredSkuData] = useState([]);
    const [selectedSessionId, setSelectedSessionId] = useState('');
    const GetTeamDetailOfShoot = useGetTeamDetailsOfShoot();

    const getSkuSessionInfo = useGetSkuSessionInfo();
    const onChange = date => {
        if (!!date) {
            setSelectedDate(date.format('YYYY-MM-DD'));
        } else {
            setSelectedDate(null);
        }
    };

    const HandlePendencyDataCreation = () => {
        GetMergedLinkForShootPendingMutation.mutateAsync([selectedDate])
            .then(() => { })
            .catch(console.log)
            .finally(() => {
                navigate('/guidelines');
            });
    };

    const HandleDownloadXLReport = () => {
        setIsDownloadingReport(true);
        GetDownloadXLSheetReportMutation.mutateAsync([selectedDate])
            .then(data => {
                var blob = new Blob([data.data], {
                    type: data.headers['content-type'],
                });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                let filename = data.headers['content-disposition'].split('filename=')[1].split('.')[0];

                link.setAttribute('download', `${filename}.xlsx`);
                document.body.appendChild(link);
                link.click();
                message.success('Downloaded!');
                setIsDownloadingReport(false);
            })
            .catch(async e => {
                let errorData = await e?.response.data.text();
                let responseMessage = JSON.parse(errorData)?.message;
                message.error(responseMessage || e?.response?.statusText);
                setIsDownloadingReport(false);
            })
            .finally(() => {
                setIsDownloadingReport(false);
            });
    };

    const checkDownloadReportDisability = () => {
        if (!selectedDate) {
            return true;
        }

        const currentSessionDate = getPhotoShootSessionDate();
        return selectedDate >= currentSessionDate;
    };

    const showTeamDetail = sessionId => {
        GetTeamDetailOfShoot.mutateAsync([sessionId])
            .then(data => {
                setCurrentShootTeamHistory(data);
            })
            .catch(e => {
                message.error(e?.response?.data?.message || 'Error');
                if (e?.response?.status === 401) logout();
            })
            .finally(() => { });
    };
    const handleSkuSessionInfoData = sessionId => {
        getSkuSessionInfo
            .mutateAsync([sessionId])
            .then(data => {
                setSkuSessionData(data.data);
                setFilteredSkuData(data.data);
            })
            .catch(e => {
                message.error(e?.response?.data?.message || 'Error');
                setSkuSessionInfoModal(false);
                if (e?.response?.status === 401) logout();
            })
            .finally(() => { });
    };
    const handleSkuSessionInfo = sessionId => {
        setSkuSessionInfoModal(true);
        setSelectedSessionId(sessionId);
        handleSkuSessionInfoData(sessionId);
    };
    const handleCloseModal = () => {
        setSkuSessionInfoModal(false);
        setSelectedSessionId('');
    };
    const handleSkuInfoSearch = e => {
        let data = [...skuSessionData];
        if (e.target.value) {
            const filteredData = data.filter(item => item.EAN?.includes(e.target.value));
            setFilteredSkuData(filteredData);
        } else {
            setFilteredSkuData(skuSessionData);
        }
    };
    const getSkuSessionInfoModal = () => {
        return (
            <DynamicModal
                title={`Sku Info || ${selectedSessionId}`}
                open={skuSessionInfoModal}
                closable={true}
                close={() => {
                    setSkuSessionInfoModal(false);
                }}
                width={'90%'}
                height={'80vh'}
                overflow="auto"
                style={{
                    top: '5%',
                }}
                component={
                    <SkuSessionInfo skuSessionInfoData={filteredSkuInfoData} handleBtnClick={handleCloseModal} handleSearch={handleSkuInfoSearch} />
                }
            />
        );
    };
    return (
        <div className="live-shoot-old">
            <Row className="top_row" gutter={[8, 8]}>
                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
                    <label style={{ textAlign: 'center' }}>Select Date: </label>
                    <DatePicker onChange={onChange} style={{ width: '200px' }} size="medium" />
                </div>
                <div>
                    <Button
                        type="default"
                        onClick={() => HandleDownloadXLReport()}
                        style={{
                            textAlign: 'center',
                            padding: '1px 2px',
                            width: '100%',
                            textOverflow: 'ellipsis',
                            backgroundColor: !checkDownloadReportDisability() ? '#52c41a' : '#A8DF8E',
                            color: 'white',
                        }}
                        loading={isDownloadingReport}
                        disabled={checkDownloadReportDisability()}
                    >
                        Download Report
                    </Button>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <Tag color="#f50" style={{ padding: '1px 3px', height: '32px', fontSize: '14px', display: 'flex', alignItems: 'center' }}>
                        <span>Total Scans:</span> <b> {sessions?.map(el => el?.completed)?.reduce((partialSum, a) => partialSum + a, 0) ?? 0}</b>
                    </Tag>
                </div>
                <div>
                    <Button
                        type="default"
                        onClick={() => HandlePendencyDataCreation()}
                        style={{ textAlign: 'center', padding: '1px 2px', width: '100%', textOverflow: 'ellipsis' }}
                    >
                        Get Pendency Data For shoot
                    </Button>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span>Auto Reload</span>
                    <Switch checked={autoReload} onChange={setAutoReload} />
                </div>
                <div style={{ textAlign: 'center' }}>
                    <Button
                        type="primary"
                        onClick={() => refetch()}
                        style={{ textAlign: 'center', padding: '1px 2px', width: '100%', textOverflow: 'ellipsis' }}
                    >
                        Reload Data
                    </Button>
                </div>
            </Row>
            {!isFetching && (
                <div className="page">
                    {!!sessions &&
                        sessions.length > 0 &&
                        sessions?.map((session, index) => {
                            return (
                                <div
                                    className="container"
                                    style={{
                                        borderColor: 'red',
                                        border: `1px dashed ${stc(session?.sessionId)}`,
                                        boxShadow: `5px 5px 10px ${stc(session?.sessionId)}`,
                                    }}
                                    key={index}
                                >
                                    <Row className="detailsContainer" style={{ color: stc(session?.sessionId) }} gutter={[4, 4]}>
                                        <Col span={4} style={{ overflowWrap: 'break-word' }}>
                                            <i>Date : </i>
                                            <b>{session?.date}</b>
                                        </Col>
                                        <Col span={6} style={{ overflowWrap: 'break-word' }}>
                                            <i>User Name : </i>
                                            <b>{`${session?.user?.name}`}</b>
                                        </Col>
                                        <Col span={7} style={{ overflowWrap: 'break-word' }}>
                                            <i>Email : </i>
                                            <b>{`${session?.user?.email}`}</b>
                                        </Col>
                                        <Col span={4} style={{ overflowWrap: 'break-word' }}>
                                            <i>SessionId : </i>
                                            <b>{`${session?.sessionId}`}</b>
                                        </Col>
                                        <Col span={1}>
                                            <UnorderedListOutlined
                                                style={{ fontSize: '18px', cursor: 'pointer' }}
                                                onClick={() => handleSkuSessionInfo(session?.sessionId)}
                                            />
                                        </Col>
                                        <Col span={1}>
                                            <Tooltip title={<span style={{ color: 'black' }}>Team Information</span>} color="white">
                                                <Button
                                                    type="text"
                                                    style={{ padding: 0, margin: 0, height: 'fit-content', float: 'right' }}
                                                    onClick={() => showTeamDetail(session?.sessionId)}
                                                >
                                                    <TeamOutlined style={{ fontSize: '15px' }} />
                                                </Button>
                                            </Tooltip>
                                        </Col>
                                    </Row>
                                    <Row className="statsContainer" gutter={[5, 5]}>
                                        <Col span={4}>
                                            <Card bordered={false} className="statistic">
                                                <Statistic
                                                    title="Pending"
                                                    value={session?.pending}
                                                    formatter={formatter}
                                                    valueStyle={{ overflowWrap: 'break-word' }}
                                                />
                                            </Card>
                                        </Col>
                                        <Col span={4}>
                                            <Card bordered={false} className="statistic">
                                                <Statistic
                                                    title={statTitle(
                                                        'Reshoot',
                                                        'Raw QC chose Reshoot for bay on the last bay that shot this SKU, because that photographer missed shots this bay was supposed to take.'
                                                    )}
                                                    value={session?.reshoot}
                                                    formatter={formatter}
                                                />
                                            </Card>
                                        </Col>
                                        <Col span={5}>
                                            <Card bordered={false} className="statistic">
                                                <Statistic title="CC Pending" value={session?.cc} formatter={formatter} />
                                            </Card>
                                        </Col>
                                        <Col span={4}>
                                            <Card
                                                bordered={false}
                                                className="statistic"
                                                style={{ backgroundColor: session?.completedDetails?.length > 0 ? '#F5F5DC' : 'auto' }}
                                            >
                                                <Statistic title="Scanned" value={session?.completed} formatter={formatter} />
                                            </Card>
                                        </Col>
                                        <Col span={7}>
                                            <Card bordered={false} className="statistic">
                                                <Statistic
                                                    title={statTitle(
                                                        'RawQC Complete',
                                                        'Raw QC finished this SKU for the bay. Includes Shoot completed by bay: this bay finished its shoot types, and pending shoot types will be shot on another bay. No reshoot is sent.'
                                                    )}
                                                    value={session?.completedByRawQC}
                                                    formatter={formatter}
                                                />
                                            </Card>
                                        </Col>
                                    </Row>
                                    {session?.completedDetails?.length > 0 ? (
                                        <Row className="completedDetailsContainer" gutter={[5, 5]}>
                                            <CompletedStats
                                                completedDetails={session?.completedDetails}
                                                isGetSessionFeching={isFetching}
                                                isSessionFetching={false}
                                            />
                                        </Row>
                                    ) : null}
                                    <Row className="bottom-row">
                                        {session?.createdAt && (
                                            <Tooltip title={moment.utc(session?.createdAt).local().format('YYYY-MM-DD HH:mm:ss')}>
                                                <div className="last-scan">
                                                    <i style={{ fontSize: '11px' }}>started: </i>
                                                    <b style={{ fontSize: '12px' }}>
                                                        {' '}
                                                        {moment.utc(session?.createdAt).local().startOf('seconds').fromNow()}
                                                    </b>
                                                </div>
                                            </Tooltip>
                                        )}
                                        {session?.lastScannedAt && (
                                            <Tooltip title={moment.utc(session?.lastScannedAt).local().format('YYYY-MM-DD HH:mm:ss')}>
                                                <div className="last-scan">
                                                    <i style={{ fontSize: '11px' }}>last scan: </i>
                                                    <b style={{ fontSize: '12px' }}>
                                                        {' '}
                                                        {moment.utc(session?.lastScannedAt).local().startOf('seconds').fromNow()}
                                                    </b>
                                                </div>
                                            </Tooltip>
                                        )}
                                        <div className="session-alive">
                                            {session?.isSessionAlive ? (
                                                <Tooltip title="Active Session">
                                                    <div
                                                        style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#79D70F' }}
                                                    ></div>
                                                </Tooltip>
                                            ) : (
                                                <Tooltip title="InActive Session">
                                                    <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: 'red' }}></div>
                                                </Tooltip>
                                            )}
                                        </div>
                                    </Row>
                                </div>
                            );
                        })}
                </div>
            )}
            {!(!!sessions && sessions.length > 0) && (
                <>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <Empty description="No Data Found For Selected Date" />
                    </div>
                </>
            )}

            {!!currentShootTeamHistory && (
                <DynamicModal
                    title="Team Information"
                    open={!!currentShootTeamHistory}
                    closable={true}
                    close={() => {
                        setCurrentShootTeamHistory(null);
                    }}
                    width={'50%'}
                    height={'70%'}
                    overflow="auto"
                    style={{
                        top: '5%',
                    }}
                    component={<TeamInformation teamHistory={currentShootTeamHistory?.teamInfoHistory || []} />}
                />
            )}
            {skuSessionInfoModal && getSkuSessionInfoModal()}
        </div>
    );
}
